import { Button, ButtonGroup } from "@mui/material";
import { useState } from "react";
import { CategoryIconPicker } from "./CategoryIconPicker";
import { categoryIconOptions, normalizeCategoryIconId } from "../lib/categoryIcons";
import { CategoryIcon } from "../lib/format";

type IconColorPickerProps = {
  ariaLabel?: string;
  className?: string;
  color: string;
  colorAriaLabel?: string;
  colorTitle?: string;
  disabled?: boolean;
  icon: string;
  iconAriaLabel?: string;
  iconDataAttribute?: "account" | "category";
  iconInputId?: string;
  iconInputName?: string;
  pickerId: string;
  pickerLabel: string;
  onColorChange: (color: string) => void;
  onIconChange: (icon: string) => void;
};

export function IconColorPicker({
  ariaLabel = "Icon and color",
  className,
  color,
  colorAriaLabel = "Choose color",
  colorTitle = "Color",
  disabled,
  icon,
  iconAriaLabel = "Choose icon",
  iconDataAttribute = "category",
  iconInputId,
  iconInputName = "icon",
  pickerId,
  pickerLabel,
  onColorChange,
  onIconChange,
}: IconColorPickerProps) {
  const [iconPickerOpen, setIconPickerOpen] = useState(false);
  const normalizedIcon = normalizeCategoryIconId(icon);
  const selectedIconLabel = categoryIconOptions.find((option) => option.id === normalizedIcon)?.label || pickerLabel;

  return (
    <div className={`category-picker-buttons${className ? ` ${className}` : ""}`} aria-label={ariaLabel}>
      <input id={iconInputId} name={iconInputName} type="hidden" value={icon} />
      <ButtonGroup variant="outlined" aria-label={`Choose ${pickerLabel.toLowerCase()} and color`}>
        <Button
          id={iconInputId ? `${iconInputId}Toggle` : undefined}
          className="category-square-button"
          type="button"
          disabled={disabled}
          aria-label={iconAriaLabel}
          aria-expanded={iconPickerOpen}
          aria-controls={pickerId}
          title={selectedIconLabel}
          onClick={() => setIconPickerOpen(true)}
        >
          <CategoryIcon icon={icon} color={color} />
        </Button>
        <Button className="category-square-button category-color-button" type="button" disabled={disabled} aria-label={colorAriaLabel} title={colorTitle}>
          <span className="category-color-preview" style={{ backgroundColor: color }}></span>
          <input
            className="category-color-input"
            name="color"
            type="color"
            value={color}
            disabled={disabled}
            required
            aria-label={colorTitle}
            onChange={(event) => onColorChange(event.target.value)}
          />
        </Button>
      </ButtonGroup>
      <CategoryIconPicker
        id={pickerId}
        iconDataAttribute={iconDataAttribute}
        label={pickerLabel}
        open={iconPickerOpen}
        selectedIcon={icon}
        onClose={() => setIconPickerOpen(false)}
        onSelect={onIconChange}
      />
    </div>
  );
}
